export const LOCATIONS = {
  fridge: {
    id:                 'fridge',
    label:              'Fridge',
    emoji:              '🧊',
    color:              '#4A90D9',
    colorLight:         '#E8F2FF',
    defaultCategories:  ['fresh_produce', 'dairy', 'meat_fish', 'bread_bakery'],
  },
  freezer: {
    id:                 'freezer',
    label:              'Freezer',
    emoji:              '❄️',
    color:              '#7B68EE',
    colorLight:         '#F0EEFF',
    defaultCategories:  ['frozen'],
  },
  pantry: {
    id:                 'pantry',
    label:              'Pantry',
    emoji:              '🏠',
    color:              '#6B9E78',
    colorLight:         '#E8F2EA',
    defaultCategories:  ['pantry_staple'],
  },
  cabinets: {
    id:                 'cabinets',
    label:              'Cabinets',
    emoji:              '🪟',
    color:              '#D4863A',
    colorLight:         '#FDF0E3',
    defaultCategories:  ['cleaning', 'personal_care'],
  },
  countertop: {
    id:                 'countertop',
    label:              'Countertop',
    emoji:              '🍳',
    color:              '#C25B4E',
    colorLight:         '#FAEAE8',
    defaultCategories:  [] as string[],
  },
  other: {
    id:                 'other',
    label:              'Other',
    emoji:              '📦',
    color:              '#9E9E9E',
    colorLight:         '#F2F2F2',
    defaultCategories:  [] as string[],
  },
} as const

export type LocationId = keyof typeof LOCATIONS

export function getDefaultLocation(freshnessCategory: string): LocationId {
  for (const [locationId, location] of Object.entries(LOCATIONS)) {
    if ((location.defaultCategories as readonly string[]).includes(freshnessCategory)) {
      return locationId as LocationId
    }
  }
  return 'pantry'
}
